import React, { useState } from 'react';
import './ACollapseTable.css';
import iconPlus from '../../Images/IconPlus.svg';
import iconMinus from '../../Images/IconMinus.svg';

const ACollapseTable = ({ item, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  let header = '';
  try {
    header = JSON.parse(item?.data)?.header || '';
  } catch (e) {
    header = item?.data || '';
  }

  return (
    <div className="collaps-table-container">
      <div className="collaps-table-header" onClick={() => setIsOpen(!isOpen)}>
        <h3>{header}</h3>
        <img
          src={isOpen ? iconMinus : iconPlus}
          alt="toggle"
          className="collaps-table-icon"
        />
      </div>

      {isOpen && (
        <div
          className="collaps-table-content"
          dangerouslySetInnerHTML={{ __html: item?.text }}
        />
      )}
    </div>
  );
};

export default ACollapseTable;
